<template>
  <div>
    <v-btn
      absolute
      fab
      right
      large
      icon
      @click="pickPhoneContact"
      style="margin-top:0px"
    >
      <v-icon>mdi-cellphone</v-icon>
    </v-btn>
    <v-card 
      class='my-0 py-0'
      flat
      v-for="group in groups" :key='group'
    >
      <v-card-title class='my-0 py-0' v-if='group'>{{group}}</v-card-title>
      <v-card-title class='my-0 py-0' v-else>Unspecified</v-card-title>
      <v-card-text class='ma-0 pa-0'>
        <v-list 
          dense
        >
          <template v-for="contact in directory.data">
            <v-list-item v-if="group==contact.directory_group"
              :key='contact.extension'
            >
              <v-list-item-avatar>
                {{contact.extension}}
              </v-list-item-avatar>

              <v-list-item-content>            
                    {{contact.name}}
              </v-list-item-content>

              <v-list-item-action>
                <v-btn icon v-on:click="toggleFavourite(contact)">
                  <v-icon v-if="isContactFavourite(contact)">mdi-star</v-icon>
                  <v-icon v-if="!isContactFavourite(contact)">mdi-star-outline</v-icon>
                </v-btn>  
              </v-list-item-action>

              <v-list-item-action>
                <v-btn icon v-on:click="pickContact(contact)">
                  <v-icon>mdi-phone</v-icon>
                </v-btn>  
              </v-list-item-action>
            </v-list-item>
          </template>
        </v-list>
      </v-card-text>
      <v-divider class='mx-0 px-0'></v-divider>
    </v-card>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="dialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{contact.name.givenName}} {{contact.name.familyName}}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-list>
            <v-list-item v-bind:key="num.id" v-for='num in contact.phoneNumbers'>
              <v-list-item-content>
                <v-list-item-title>{{num.value}}</v-list-item-title>
                <v-list-item-subtitle>{{num.type}}</v-list-item-subtitle>
              </v-list-item-content>

              <v-btn
                icon 
                v-on:click="chooseContact(num.value, 'message', contact)">
                <v-icon color="indigo">
                  mdi-message
                </v-icon>
              </v-btn>

              <v-btn
                icon 
                v-on:click="chooseContact(num.value, 'phone', contact)">
                <v-icon color="indigo">
                  mdi-phone
                </v-icon>
              </v-btn>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-text v-if="showFromNumbers">
          <p>Send message to {{currentContactNumber}}</p>
          <select
            label="Choose number to send from" 
            class="form-control" 
            v-model="currentContactFromNumber">
            <option v-for="smsFromNumber in smsFromNumbers" v-bind:value="smsFromNumber.number" v-bind:key='smsFromNumber.number'>{{smsFromNumber.number}} - {{smsFromNumber.entity_name}}</option>
          </select>
          <v-btn
                  v-on:click="sendSMS(currentContactNumber, currentContactName, currentContactFromNumber)">
                  Create SMS Contact
          </v-btn>
      </v-card-text>
    </v-card>
      
    </v-dialog>
  </div>
</template>

<script >
import Session from '../components/Session';
import ChatCommon from '../mixins/chatcommon';
import Common from '../mixins/common.vue';
import Api from '../api.js';
import { mapState } from 'vuex';
export default {
  mixins: [Common, ChatCommon],
  components: {
    'session': Session,
  },
  data: function() {
    return {
      clipboardText: "",
      contact: { name: {}, displayName: null, nickname: null, phonenumbers: {} },
      contacts: {},
      directory: {},
      groups: [],
      //number: null,
      dialog: false,
      showFromNumbers: false,
      currentContactName: null,
      currentContactNumber: null,
      currentContactFromNumber: null,
    }
  },
  watch: {

  },
  computed: {
    ...mapState(['devices', 'device']),
    smsFromNumbers: {
      get() {
        return this.$store.state.smsFromNumbers;
      }
    },
    lineKeys: {
      get() { return this.$store.state.lineKeys },
      set: function(v) { this.$store.commit('lineKeys',v)}

    },
  },
  methods: {
    updateDirectory: function() {
      this.$http
        .get(global.apiurl + "/directory&token=" + this.click2call)
        .then( response => {
          this.directory = response.body;
          console.log('set directory');
          console.log(this.directory);

          for (var i = 0; i < this.directory.data.length; i++) {
            var c = this.directory.data[i];
            if (c.directory_group == null)
            {
              //c.directory_group = 'Unset';
            }

            if (!this.groups.includes(c.directory_group))
            {
              this.groups.push(c.directory_group);
            }
          }
          this.groups.sort();
          console.log('dialer2 directory is ', this.directory);
          console.log('dialer2 directory data is ', this.directory.data);

        });
    },
    showModal: function(name) {
      //this.number = null;
      //this.$modal.show(name);
    },
    isContactFavourite: function(contact) {
      for (let i=0;i<this.lineKeys.length;i++) {
        let lk = this.lineKeys[i];
        if (contact.extension == lk.number) {
          return true;
        }
      }
      return false;
    },
    hideModal: function(name) {
      this.$modal.hide(name);
      if (this.number) {
        this.$emit('selectNumber', this.number);
      }
    },
    onOpen: function () {
        this.sorting = !this.sorting;
      },
    onClose: function () {
      this.sorting = !this.sorting;
    },
    pickContact: function(contact) {
      this.number = contact.extension;
      global.api.userAction('directory_dial', this.number, 'webphone');
      this.$sip.dial(this.number);
    },
    pickPhoneContact: function() {
      navigator.contacts.pickContact(contact => {
        this.contact = contact;
        this.dialog = true;
      });
    },
    toggleFavourite: async function(contact) {
      let api = new Api(global.gqlClient());
      if (this.isContactFavourite(contact)) {
        // get the favourite/linekey and remove it
        let newLineKeys = [];
        for (let i=0;i<this.lineKeys.length;i++) {
          let lk = this.lineKeys[i];
          if (contact.extension == lk.number) {
            newLineKeys = await api.deleteLineKey(lk, this.device);
          }
        }
        this.lineKeys = newLineKeys;
      } else {
        // add the line key as a custom number
        let lineKey = await api.addLineKey(contact.name, contact.user_service_id, 'N', 'Y', 'N', this.device.device_id, this.device.click2call_token);
        if (lineKey) {
          //self.$dialog.alert('Lin');
          this.lineKeys.push(lineKey);
          
        } else {
          self.$dialog.alert('Favourite not created: ' + data.message);
        }
      }
    },
    chooseContact: function(number, type, contact) {
      if (type == 'phone') {
        this.$store.commit('number', number);
        this.$router.push('/dialer2');
      } else if (type == 'message') {
        this.currentContactName = contact.name.givenName + ' ' + contact.name.familyName;
        this.currentContactNumber = number;
        this.showFromNumbers = true;
        //this.addSMSContact(contact.displayName, number, )
      }
    },
    sendSMS: function() {
      this.addSMSContact(this.currentContactName, this.currentContactNumber, this.currentContactFromNumber);
      this.$router.push('/chats');
    }
  },
  beforeMount() {
    this.updateDirectory();
  },
  filters: {

  },
}


</script>

<style scoped>
.fa-icon {
  width: auto;
  height: 1em; /* or any other relative font sizes */
}
body {
  margin: 0;
  border: 0;
  padding: 0;
  overflow: hidden;
}


</style>
